export const AUTH_TOKEN_NAME = "appetize-auth";
export const USER_ID = "appetize-userid";
export const GUEST_TYPE = "GUEST";
export const IS_VENDOR_OPEN = "isOpen";
export const DEFAULT_TIMEZONE = "America/Los_Angeles";
export const CUSTOM_AVAILABILITY_FIELD = "iwVendorStatus"; //unused
export const DEFAULT_TIP = 18;
export const MAPI_API_TYPE = "MAPI";
export const OAPI_API_TYPE = "OAPI";
export const CATEGORIES_ORDER_MASK = ["food", "drink", "merch"];
export const MAPI_AP_PROCESSOR = "authorize.net";
export const FREEDOMPAY_AP_PROCESSOR = "freedompay";
export const APPLICATION_NAME_FRIENDLY = "Interact Web";
export const APPLICATION_NAME = "InteractWeb";
export const ORDER_AHEAD_TIMESLOT_DIFF = 15;
export const REWARDS_GUIDANCE_DEFAULT_TEXT =
  "Use the email address tied to your ticketing account to automatically earn & use rewards!";
export const USER_LOGIN = "userLogin";
export const GUEST_LOGIN = "guestLogin";
export const NOT_IDENTIFIED = "notIdentified";

export const ROUTE_NAMES = {
  NOT_FOUND: "404",
  RESET_PASSWORD: "ResetPassword",
  VENUE_CONTAINER: "VenueContainer",
  DEEP_LINK_SECTION: "DeepLinkBySection",
  DEEP_LINK_ROW: "DeepLinkByRow",
  DEEP_LINK_SEAT: "DeepLinkBySeat",
  VENDOR_PICKER: "VendorPicker",
  VENDOR: "Vendor",
  OFFERINGS: "Offerings",
  FAVORITES: "Favorites",
  ORDER_AGAIN: "OrderAgain",
  MENU: "Menu",
  SHOPPING_CART: "ShoppingCart",
  CHECKOUT: "Checkout",
  LOGIN: "Login",
  REGISTRATION: "Registration",
  FORGOT_PASSWORD: "ForgotPassword",
  CONTINUE_AS_GUEST: "ContinueAsGuest",
  USER_PROFILE: "UserProfile",
  ORDER_CONFIRMATION: "OrderConfirmation",
  ORDER_DETAILS: "OrderDetailsPage",
  ORDER_HISTORY: "OrderHistoryPage",
  CHANGE_PASSWORD: "ChangePasswordPage",
  USER_INFO: "UserInformationPage",
  BILLING_INFO: "BillingInformationPage",
  HELP: "HelpPage",
  WALLET: "Wallet"
};

export const GUEST_CHECKOUT_MODAL_CONFIG = {
  name: "CheckoutModal",
  height: "auto",
  width: 400,
  adaptive: true,
  scrollable: true
};

export const TOAST_COMPONENT_OPTIONS = {
  // more info https://github.com/Maronato/vue-toastification/tree/next
  position: "bottom-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: false,
  icon: false,
  rtl: false,
  toastClassName: "iw-toaster-flash-message"
};

export const LANGUAGES = {
  enus: "en-us"
};

//Warnings & errors constants
export const ERROR_DEFAULT = "Unknown error";
export const ERROR_PROCESSING_PPI_PAYMENT = (paymentName, cardNumber) =>
  `Your ${paymentName ?? "Card"} - ${cardNumber ?? "****"} payment could not be processed.`;
export const ERROR_PROCESSING_PPI_PAYMENT_INSUFFICIENT_FUNDS = (paymentName, cardNumber) =>
  `Your ${paymentName ?? "Card"} - ${
    cardNumber ?? "****"
  } payment has insufficient funds available for this transaction. The applied payment has been adjusted. Please add a new form of payment and try again.`;
export const ERROR_PROCESSING_PPI_PAYMENTS =
  "Your payment could not be completed. Please add a new form of payment and try again.";
export const ERROR_APPLYING_PPI_TENDER = (name, credential) =>
  `Your ${name} account ${credential} could not be applied to this order. Please retry below.`;
export const ERROR_PROCESSING_PAYMENT = "Your payment could not be processed. Please try again.";
export const ERROR_PROCESSING_AP_PAYMENT = "Your ApplePay payment could not be processed. Please try again.";
export const DECLINED_AP_PAYMENT = "Your ApplePay payment was declined. Please try again.";
export const ERROR_GET_AMENITIES = "Enter a valid card number";
export const ERROR_AMENITY_ALREADY_APPLIED = "This payment has already been applied to this order.";
export const ERROR_AMENITY_INELIGIBLE = "This payment is ineligible for the items in your cart.";
export const SCAN_ERROR_MESSAGES = {
  noCamera: { header: "Sorry, this experience requires a device camera to scan items!", body: "" },
  noMatches: { header: "Sorry, no matches found!", body: "Please see a staff member." },
  cannotBeAdded: { header: "Sorry, item cannot be added to your cart!", body: "" },
  alcoholNotPermitted: { header: "Sorry, alcohol sales are not permitted for this vendor!", body: "" },
  notAvailable: { header: "Sorry, item not available!", body: "Please see a staff member - item inactive." },
  unavailableDayPart: {
    header: "Sorry, item not available!",
    body: "Please see a staff member - item not available at current time."
  }
};
export const ERROR_VENDOR_SELECTED_NOT_AVAILABLE = "Sorry, The selected vendor is no longer available.";
export const ERROR_PICK_UP_TIME_SELECTED_NOT_AVAILABLE = "Order Ahead is no longer available for this vendor.";
export const ERROR_PICK_UP_TIME_NO_LONGER_AVAILABLE = "Scheduled order time is no longer valid. Please select a different time.";
export const SELECT_PICK_UP_TIME_PROMPT = "Please select a time to pickup your order.";
export const ERROR_MODAL_ORDERAHEAD = {
  VENDOR_OPEN_NO_TIME_SLOTS: `Sorry, but the time you've selected is no longer available.  We're currently not accepting online orders.`,
  VENDOR_CLOSED_NO_TIME_SLOTS: `Sorry, but the time you've selected is no longer available.  Online ordering is now closed.`,
  VENDOR_CLOSED: `Sorry, but we are no longer open.`,
  TWO_OR_MORE_SLOTS_AVAILABLE: `Sorry, but the time you've selected is no longer available. The nearest available time is:`,
  ONLY_ONE_SLOT_AVAILABLE: `Sorry, but the time you've selected is no longer available. The only time available:`,
  MODAL_TITLE: `Time no longer available`,
  MODAL_TITLE_CLOSED: `Store closed`,
  MODAL_BUTTON_WITH_SLOTS: `Accept new time`,
  MODAL_BUTTON_GO_VENDORS: `See other vendors`,
  MODAL_BUTTON_GO_MENU: `Go to the Menu`
};
export const ITEM_LIMIT_REACHED_MSG = "Item limit reached";
export const REQUIRED_ERR_MSG = "Please check the highlighted fields";
export const INVALID_PASSWORD_ERR_MSG =
  "Your password must be at least 8 characters long, contain both uppercase and lowercase letters, and at least one number and one special character";
export const DIFF_PASSWORD_ERR_MSG = "Passwords must be identical";
export const EMPTY_WALLET_MSG =
  "You currently do not have any payment methods saved to your wallet. You can select ‘Save to my Wallet’ when adding a new payment method at checkout to save it for future use.";
export const DELETE_CARD_WALLET_ERROR = "Unable to remove card from wallet";
export const DELETE_CARD_WALLET_SUCCESS = "Succesfully removed card from wallet";
export const SAVE_CARD_WALLET_SUCCESS = "Succesfully saved card to wallet";
export const SAVE_CARD_WALLET_ERROR = "Unable to save card to wallet";

//Payments consts
export const PAY_TYPE_APPLE = "applePay";
export const PAY_TYPE_GOOGLE = "googlePay";
export const PAY_TYPE_CREDIT_DEBIT = "credit-debt";
export const STORED_CREDIT_CARD = "stored-card";
export const STORED_ACCOUNT_CARD = "account-card";

export const APPLE_PAY_PAYMENT_TYPE = 7;
export const CREDIT_CARD_PAYMENT_TYPE = 1;
export const ELAVON_SUBPAYMENT_TYPE = 36;
export const FREEDOMPAY_SUBPAYMENT_TYPE = 32;

//Tokenized
export const TOKENIZED_PAYMENT_TYPE = 22;
export const ELAVON_GATEWAY_ID = 45; //tokenized gateway id
export const FREEDOMPAY_GATEWAY_ID = 22; //tokenized gateway id

export const FILTERED_TENDERS = [
  { paymentType: 15, subpaymentType: 0 },
  { paymentType: 14, subpaymentType: 0 },
  { paymentType: 1, subpaymentType: 0 }, // CC
  { paymentType: 22, subpaymentType: null } // tokenized payment
  // { paymentType: -1, subpaymentType: null }, // anything with a -1 payment type
  // { paymentType: 2,  subpaymentType: null }, // cash
];

export const SKIDATA_PAYMENT_INFO = {
  getReductions: true,
  paymentType: 31,
  subpaymentType: 34,
  balancePaymentType: 15,
  balanceSubPaymentType: 14,
  MAPIPaymentType: 15,
  MAPISubpaymentType: 0
};

export const LAVA_PAYMENT_INFO = {
  getReductions: false,
  paymentType: 11,
  subpaymentType: 23,
  MAPIPaymentType: 11,
  MAPISubpaymentType: 23
};

export const FORTRESS_PAYMENT_INFO = {
  getReductions: false,
  paymentType: 11,
  subpaymentType: 5,
  MAPIPaymentType: 11,
  MAPISubpaymentType: 5
};

export const GIVEX_PAYMENT_INFO = {
  getReductions: false,
  paymentType: 11,
  subpaymentType: 7,
  MAPIPaymentType: 11,
  MAPISubpaymentType: 7
};

export const STADIS_PAYMENT_INFO = {
  getReductions: false,
  paymentType: 11,
  subpaymentType: 12,
  MAPIPaymentType: 11,
  MAPISubpaymentType: 12
};

export const VENUETIZE_PAYMENT_INFO = {
  getReductions: true,
  paymentType: 11,
  subpaymentType: 31,
  MAPIPaymentType: 11,
  MAPISubpaymentType: 31
};

export const PAYMENT_TYPES = {};
PAYMENT_TYPES[`${SKIDATA_PAYMENT_INFO.paymentType}|${SKIDATA_PAYMENT_INFO.subpaymentType}`] = SKIDATA_PAYMENT_INFO;
PAYMENT_TYPES[`${LAVA_PAYMENT_INFO.paymentType}|${LAVA_PAYMENT_INFO.subpaymentType}`] = LAVA_PAYMENT_INFO;
PAYMENT_TYPES[`${FORTRESS_PAYMENT_INFO.paymentType}|${FORTRESS_PAYMENT_INFO.subpaymentType}`] = FORTRESS_PAYMENT_INFO;
PAYMENT_TYPES[`${GIVEX_PAYMENT_INFO.paymentType}|${GIVEX_PAYMENT_INFO.subpaymentType}`] = GIVEX_PAYMENT_INFO;
PAYMENT_TYPES[`${STADIS_PAYMENT_INFO.paymentType}|${STADIS_PAYMENT_INFO.subpaymentType}`] = STADIS_PAYMENT_INFO;
PAYMENT_TYPES[`${VENUETIZE_PAYMENT_INFO.paymentType}|${VENUETIZE_PAYMENT_INFO.subpaymentType}`] = VENUETIZE_PAYMENT_INFO;

export const PPI_PAYMENT_INFO = [
  //used by ununsed functions
  SKIDATA_PAYMENT_INFO,
  LAVA_PAYMENT_INFO,
  FORTRESS_PAYMENT_INFO,
  GIVEX_PAYMENT_INFO,
  STADIS_PAYMENT_INFO,
  VENUETIZE_PAYMENT_INFO
];

export const PRICING_MODE = {
  increasesParentPrice: "INCREASES_PARENT_PRICE",
  includedInParentPrice: "INCLUDED_IN_PARENT_PRICE"
};

//UI constants
export const DISPLAY = {
  minDesktopWidth: 768
};

export const ORIENTATION = {
  portrait: "portrait",
  landscape: "landscape"
};

// Modal constants
export const MODAL = {
  dialogName: "CustomDialog",
  dialogDesktopWidth: 420,
  dialogMobileMargins: 36
};

export const TOASTER_NAME = "toaster";

export const DISABLED_ITEMS_MODAL_TEXT = {
  itemsChangedMessage: "The menu has changed, and some items were removed from your cart.",
  alcoholChangedMessage: "Sorry, alcohol sales are now closed, and these items were removed from your cart."
};

export const MODALS = {
  ScanModal: "ScanModal"
};

//Sentry
export const DEV_SENTRY_SAMPLE_RATE = 1;
export const PROD_SENTRY_SAMPLE_RATE = 0.2;
export const SENTRY_ERRORS = {
  ERROR_PAY_SESSION: "ERROR_PAY_SESSION",
  ERROR_LOAD_EXTCDN: "ERROR_LOAD_EXTCDN",
  ERROR_OAPI_ELAVON_AP_CHECKOUT: "ERROR_OAPI_ELAVON_AP_CHECKOUT",
  ERROR_CHECKOUT: "ERROR_CHECKOUT",
  ERROR_CHECKOUT_APPLING_PPI: "ERROR_CHECKOUT_APPLING_PPI",
  ERROR_OAPI_FP_PAY: "ERROR_OAPI_FP_PAY",
  ERROR_OAPI_ELAVON_CC_CHECKOUT: "ERROR_OAPI_ELAVON_CC_CHECKOUT",
  ERROR_OAPI_VS_SAVETOKEN: "ERROR_OAPI_VS_SAVETOKEN",
  ERROR_OAPI_VS_DELETETOKEN: "ERROR OAPI VS_DELETETOKEN",
  ERROR_OAPI_IFRAME_ERROR: "ERROR_OAPI_IFRAME_ERROR",
  ERROR_MAPI_FP_AP_INIT: "ERROR_MAPI_FP_AP_INIT",
  ERROR_MAPI_FP_AP_AUTH: "ERROR_MAPI_FP_AP_AUTH",
  ERROR_MAPI_FP_AP_VALIDATE: "ERROR_MAPI_FP_AP_VALIDATE",
  ERROR_MAPI_FP_PAYSHEET_PAYMENT_AUTH_FAILED: "ERROR_MAPI_FP_PAYSHEET_PAYMENT_AUTH_FAILED",
  ERROR_MAPI_AP_PROCESS: "ERROR_MAPI_AP_PROCESS",
  ERROR_FP_AP_PROCESS: "ERROR_FP_AP_PROCESS",
  ERROR_OAPI_PROCESS_AMENITY: "ERROR_OAPI_PROCESS_AMENITY",
  ERROR_CARDINFO: "ERROR_CARDINFO",
  ERROR_OAPI_PROCESS_REDUCTION: "ERROR_OAPI_PROCESS_REDUCTION",
  ERROR_VISITOR_SERVICE: "ERROR_VISITOR_SERVICE",
  ERROR_PPI_SERVICE: "ERROR_PPI_SERVICE",
  ERROR_COMMON_SERVICE: "ERROR_COMMON_SERVICE",
  ERROR_ORDERING_SERVICE: "ERROR_ORDERING_SERVICE",
  ERROR_CONNECT_SERVICE: "ERROR_CONNECT_SERVICE",
  ERROR_NAVIGATION_FAILURE: "ERROR_NAVIGATION_FAILURE",
  ERROR_FETCH_VENDORS: "ERROR_FETCH_VENDORS",
  ERROR_UPDATING_SERVER_CONFIG: "ERROR_UPDATING_SERVER_CONFIG",
  ERROR_FETCH_FEATURE_FLAGS: "ERROR_FETCH_FEATURE_FLAGS",
  ERROR_PPI_REPORT_ORDER: "ERROR_PPI_REPORT_ORDER",
  ERROR_ADDING_GTM_PLUGIN: "ERROR_ADDING_GTM_PLUGIN",
  ERROR_TRACKING_GTM_PURCHASE_EVENT: "ERROR_TRACKING_GTM_PURCHASE_EVENT"
};

// Vuex
export const VUEX_STORAGE_KEY = "iw-vuex-store";

//Storage maintenance
export const USER_ACTIONS_FILTERED_MODULES = ["common", "spinner"];
export const USER_ACTIONS_FILTERED_MUTATIONS = [
  "vendor/setVendorStatus",
  "cart/resetState",
  "cart/resetCheckoutState",
  "cart/resetDiscountState",
  "cart/resetOAPIState",
  "vendor/resetActiveVendor",
  "delivery/resetState",
  "level/resetActiveLevelSelection",
  "orderAhead/resetState",
  "user/resetState",
  "user/resetFavoritesState",
  "dayParts/resetState",
  "level/resetLevelLists",
  "theme/resetState",
  "vendor/resetVendorLists",
  "vendor/resetMenuItemsFilterState",
  "venue/resetState",
  "venueSettings/resetState",
  "vendor/resetMenuItemsState"
];

export const MIN_DESKTOP_WIDTH = 767;

//Sentry replays config
export const DEFAULT_REPLAY_SESSION_SAMPLE_RATE = 0.1;
export const DEFAULT_REPLAY_ERROR_SAMPLE_RATE = 0.2;
export const DEFAULT_NETWORK_REQUEST_HEADERS = [];
export const DEFAULT_NETWORK_RESPONSE_HEADERS = [];
